export const sendMessageByUser = /* GraphQL */ `
  mutation SendMessageByUser($input: SendMessageByUserInput!) {
    sendMessageByUser(input: $input) {
      message {
        id
        body
        status
        conversationId
        agentId
        userId
        campaignId
        sender
        createdAt
        isInitial
        updatedAt
      }
    }
  }
`;

export const updateConversation = /* GraphQL */ `
  mutation UpdateConversation(
    $input: UpdateConversationInput!
    $condition: ModelConversationConditionInput
  ) {
    updateConversation(input: $input, condition: $condition) {
      id
      status
      userId
      agentId
      campaignId
      organizationId
      twilioParticipantId
      twilioConversationId
      participantPhoneNumber
      participantFirstName
      participantLastName
      participantLinkedInProfile
      messagesCount
      createdAt
      updatedAt
      isRead
      messages {
        items {
          id
          body
          createdAt
          updatedAt
          sender
        }
        nextToken
      }
      pastOngoingConversationId
      isHumanTakeover
    }
  }
`;

export const updateUnansweredQuestion = /* GraphQL */ `
  mutation UpdateUnansweredQuestion(
    $input: UpdateUnansweredQuestionInput!
    $condition: ModelUnansweredQuestionConditionInput
  ) {
    updateUnansweredQuestion(input: $input, condition: $condition) {
      id
      summary
      isAnswered
      conversationId
      campaignId
      associatedMessageId
      associatedMessage {
        id
        body
        sender
        userId
        status
        conversationId
        agentId
        twilioMessageId
        twilioErrorCode
        campaignId
        createdAt
        deliveredAt
        readAt
        isInitial
        updatedAt
        messageUnansweredQuestionId
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;

export const restartConversation = /* GraphQL */ `
  mutation RestartConversation($input: RestartConversationInput!) {
    restartConversation(input: $input) {
      id
      status
      userId
      agentId
      campaignId
      twilioParticipantId
      twilioConversationId
      participantPhoneNumber
      participantFirstName
      participantLastName
      participantLinkedInProfile
      participantEmailAddress
      messagesCount
      createdAt
      updatedAt
      isRead
      user {
        id
        name
      }
      attachments {
        items {
          id
          media {
            twilioMediaSid
            contentType
            fileName
            classifiedDocumentType
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      messages {
        items {
          id
          body
          createdAt
          updatedAt
          sender
          templateId
          template {
            type
          }
        }
        nextToken
      }
      pastOngoingConversationId
      isWebChatJoined
      twilioRedirectConversationId
      twilioRedirectParticipantId
      screeningQuestionsOutcome {
        screeningQuestion
        questionOutcome
        responseSummary
      }
      errorCode
      needsReview
      isHumanTakeover
      timeToFirstResponse
      timeToComplete
      completedAt
      repliesCount
      atsCandidateId
      atsApplicationId
    }
  }
`;
